module.exports = __webpack_public_path__ + "assets/img/67b998409e4799f75c9e47387a0bb160.png";